var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"select-board select-button-box"},_vm._l((_vm.selectData),function(item,index){return _c('button',{key:index},[_vm._v(_vm._s(item.price))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }